import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/nathan/Documents/GitHub/wmn-cms-docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "editing-existing-content"
    }}>{`Editing Existing Content`}</h1>
    <h2 {...{
      "id": "content-within-the-tree-view"
    }}>{`Content Within the Tree View`}</h2>
    <p>{`This documentation is intended as a guide that will be helping you gain an overview of how you edit existing content.`}</p>
    <ol>
      <li parentName="ol">{`When you are looking to edit content, the first thing you should do is locate the page you want to edit content on. This can be done in the section tree on the left side of the screen.`}</li>
      <li parentName="ol">{`When you have located the page, you want to edit and clicked onto it.`}</li>
    </ol>
    <p>{`You will be presented with the content of the page (if there is any). This content will be in the middle of the page (see image). The content is everything inside the red box. On this page there are three kinds of fields for content.`}</p>
    <ul>
      <li parentName="ul">{`A text box for the title.`}</li>
      <li parentName="ul">{`A media picker for the image.`}</li>
      <li parentName="ul">{`A rich text editor.`}</li>
    </ul>
    <p>{`Which fields you see in this area and what type of content you will be able to fill in, is dependent on how the developers has built the site.`}</p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`After you have edited the content, you can click the save button to save the edits you did without publishing it.`}</li>
      <li parentName="ol">{`At this point it is recommended that you preview the changes that you did, which you can do by pressing the preview button located to the left of the save button.`}</li>
      <li parentName="ol">{`Finally, after you have done the preview and confirmed that the changes are how you like it then you can click save and publish, to publish the changes you did.`}</li>
    </ol>
    <p>{`You can learn more about that in the Save and publish article.`}</p>
    <h2 {...{
      "id": "list-view-pages"
    }}>{`List View Pages`}</h2>
    <p>{`Some of the pages in your website may use a list view style which shows child pages in a table format rather than the standard tree view.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      